import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/times-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM357.8 193.8L295.6 256 357.8 318.2C362.5 322.9 362.5 330.5 357.8 335.2L335.2 357.8C330.5 362.5 322.9 362.5 318.2 357.8L256 295.6 193.8 357.8C189.1 362.5 181.5 362.5 176.8 357.8L154.2 335.2C149.5 330.5 149.5 322.9 154.2 318.2L216.4 256 154.2 193.8C149.5 189.1 149.5 181.5 154.2 176.8L176.8 154.2C181.5 149.5 189.1 149.5 193.8 154.2L256 216.4 318.2 154.2C322.9 149.5 330.5 149.5 335.2 154.2L357.8 176.8C362.5 181.5 362.5 189.1 357.8 193.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/times-circle.js
// module id = KA9W
// module chunks = 144